const getBrandCSSClasses = (brand) => {
    return (brand.id && brand.id === 'tnt-sports') ? 'c-tile__channel-logo c-tile__channel-logo--tnt-sports' : 'c-tile__channel-logo';
};

export { getBrandCSSClasses };
